import React, { FC, useEffect } from 'react'
// import ReactGA from 'react-ga'
import { useDispatch, useSelector } from 'react-redux'
import { ThunkDispatch } from '../../@types/store'
import history from '../../helpers/history'
import { ApplicationState } from '../../store'
import { requestPrefix } from '../../store/prefix/prefix.actions'
import { requestGamesHome } from '../../store/gamesHome/gamesHome.action'
import { Themes } from '../../utils/Theme'
import { Helmet } from 'react-helmet';
import reactManifest from 'react-manifest';
import { Button, Typography, Row, Space, Result } from 'antd';
import {
	ExclamationCircleOutlined,
	WifiOutlined,
	ToolOutlined,
	SettingOutlined,
	ClockCircleOutlined,
	HeartOutlined
} from '@ant-design/icons';
// import TagManager from 'react-gtm-module'

// const TRACKING_ID = 'G-1LXWHZHGZM'
// ReactGA.initialize(TRACKING_ID);

const PrefixContainer: FC = ({ children }) => {
	const dispatch: ThunkDispatch = useDispatch()
	const prefixState = useSelector((state: ApplicationState) => state.prefix)

	useEffect(() => {
		dispatch(requestPrefix())
		dispatch(requestGamesHome(prefixState.info?.game))
	}, [dispatch, prefixState.info?.game])

	useEffect(() => {
		if (prefixState.isLoaded && prefixState.info) {
			document.title = prefixState.info.title
			const colorPrimary = prefixState?.info?.themeColor?.primaryStart || '#005de7';

			const icon = document.querySelector(`link[rel="icon"]`)
			const appleicon = document.querySelector(`link[rel="apple-touch-icon"]`)
			const shortcuticon = document.querySelector(`link[rel="shortcut icon"]`)

			const Theme_color = document.querySelector(`meta[name='theme-color']`)
			const Theme_color_msapplication = document.querySelector(`meta[name='msapplication-navbutton-color']`)
			const Theme_color_msapplication_titlecolor = document.querySelector(`meta[name='msapplication-TileColor']`)
			const Theme_color_apple_mobile_web_app = document.querySelector(`meta[name='apple-mobile-web-app-status-bar-style']`)

			// const metaOgTitle = document.querySelector(`meta[property='og:title']`)
			// const metaOgDescription = document.querySelector(`meta[property='og:description']`)
			// const metaOgImage = document.querySelector(`meta[property='og:image']`)
			// const metaOgUrl = document.querySelector(`meta[property='og:url']`)
			// const metaOgType = document.querySelector(`meta[property='og:type']`)

			// if (metaOgTitle && metaOgDescription && metaOgImage && metaOgUrl && metaOgType) {
			// 	metaOgTitle.setAttribute('content', prefixState.info.title)
			// 	metaOgDescription.setAttribute('content', "พัฒนาอย่างใส่ใจทุกการเล่นบาคาร่า คาสิโนออนไลน์ ที่ดีที่สุด เพื่อประสบการณ์ที่ดีของผู้เล่นอย่างแท้จริง")
			// 	metaOgImage.setAttribute('content', prefixState.info.icon ? prefixState.info.icon : prefixState.info.logo)
			// 	metaOgUrl.setAttribute('content', window.location.hostname)
			// 	metaOgType.setAttribute('content', "website")
			// }

			if (icon && appleicon && shortcuticon) {
				icon.setAttribute('href', prefixState.info.icon ? prefixState.info.icon : prefixState.info.logo)
				appleicon.setAttribute('href', prefixState.info.icon ? prefixState.info.icon : prefixState.info.logo)
				shortcuticon.setAttribute('href', prefixState.info.icon ? prefixState.info.icon : prefixState.info.logo)
			}

			if (Theme_color && Theme_color_msapplication && Theme_color_msapplication_titlecolor && Theme_color_apple_mobile_web_app) {
				Theme_color.setAttribute('content', colorPrimary)
				Theme_color_msapplication.setAttribute('content', colorPrimary)
				Theme_color_msapplication_titlecolor.setAttribute('content', colorPrimary)
				Theme_color_apple_mobile_web_app.setAttribute('content', colorPrimary)
			}

			// add style to body
			document.body.style.setProperty('background-color', '#121416')

			// // window.location.host === "jedi.bet" && 
			// // && window.location.host !== "pg89.bet"
			// if (prefixState.info.prefix === "JEDI" && (window.location.host !== "pg89.bet" && window.location.host !== "pgauto68.com")) {
			// 	// var ask = window.confirm("ประกาศแจ้งเปลี่ยนทางเข้าเล่น กรุณาเข้าเล่นผ่านเว็บไซต์ใหม่ที่ https://pg89.bet ขอบคุณค่ะ ทางเข้าเล่นเก่าจะปิดเร็วๆนี้");
			// 	var ask = window.alert("ประกาศแจ้งเปลี่ยนทางเข้าเล่น กรุณาเข้าเล่นผ่านเว็บไซต์ใหม่ที่ pg89.bet ขอบคุณค่ะ ทางเข้าเล่นเก่าจะปิดเร็วๆนี้");
			// 	// if (ask) {
			// 	// 	window.location.href = "https://pg89.bet";
			// 	// } else {
			// 	// 	window.location.href = "https://pg89.bet";
			// 	// }
			// }
		}
	}, [prefixState])

	// useEffect(() => {
	// 	// const unsub = history.listen((loc) => {
	// 	// 	if (prefixState.isLoaded && prefixState.info) {
	// 	// 		const TRACKING_ID = prefixState.info?.googleAnalytic
	// 	// 		if (TRACKING_ID) {
	// 	// 			const tagManagerArgs = {
	// 	// 				gtmId: TRACKING_ID,
	// 	// 				dataLayer: {
	// 	// 					page: loc.pathname
	// 	// 				}
	// 	// 			}
	// 	// 			TagManager.initialize(tagManagerArgs)
	// 	// 		}
	// 	// 	}
	// 	// })
	// 	// return () => {
	// 	// 	unsub()
	// 	// }
	// 	const TRACKING_ID = prefixState.info?.googleAnalytic
	// 	if (TRACKING_ID && history.location.pathname) {
	// 		const tagManagerArgs = {
	// 			gtmId: TRACKING_ID
	// 		}
	// 		TagManager.initialize(tagManagerArgs)
	// 	}
	// }, [prefixState])

	useEffect(() => {
		const shortName = window.location.host.toLocaleUpperCase().replace('WWW.', '');

		const tagNameIos = document.createElement('meta');
		tagNameIos.name = 'apple-mobile-web-app-title';
		tagNameIos.content = shortName;
		document.head.appendChild(tagNameIos);

		const tagNameAndroid = document.createElement('meta');
		tagNameAndroid.name = 'application-name';
		tagNameAndroid.content = shortName;
		document.head.appendChild(tagNameAndroid);
		const manifestDetails = {
			"name": shortName,
			"short_name": shortName
		};

		reactManifest.update(manifestDetails, "#manifest-placeholder");

		return () => {
			document.head.removeChild(tagNameIos);
			document.head.removeChild(tagNameAndroid);
		};
	}, []);

	if (!prefixState.isLoaded) {
		return (
			<></>
		)
	}

	if (prefixState.isLoaded && !prefixState.info) {
		return (

			<div className="error-container">
				<div className="error-content">
					{/* Animated Error Icon */}
					<div className="error-icon-wrapper">
						<div className="error-icon-bg">
							<ExclamationCircleOutlined className="error-icon" />
						</div>
						<div className="wifi-icon-wrapper">
							<WifiOutlined className="wifi-icon" />
						</div>
					</div>

					<Space direction="vertical" align="center" className="error-text-content">
						<div className="error-title">
							ไม่สามารถโหลดข้อมูลได้
						</div>

						<div className="error-description">
							เกิดข้อผิดพลาดในการโหลด รีเฟรชหน้าเว็บใหม่อีกครั้ง
						</div>
					</Space>
				</div>
			</div>
		)
	}
	if (prefixState.isLoaded && prefixState.info?.maintenance) {
		return (
			<div className="maintenance-container">
				<div className="maintenance-content">
					<div className="maintenance-icon-wrapper">
						<div className="maintenance-icon-bg">
							<ToolOutlined className="maintenance-icon" />
						</div>
						<div className="clock-icon-wrapper">
							<ClockCircleOutlined className="clock-icon" />
						</div>
					</div>

					<Space direction="vertical"  align="center" className="maintenance-text-content">
						<div className="error-title">
							ปิดปรับปรุงชั่วคราว
						</div>

						<div className="error-description">
							เรากำลังพัฒนาระบบให้ดีขึ้นเพื่อประสบการณ์ใช้งานที่ดี
							หากดำเนินการแล้วเสร็จจะแจ้งให้ทราบอีกครั้ง<br />ขออภัยในความไม่สะดวกค่ะ
						</div>
					</Space>
				</div>
			</div>
		)
	}

	return (
		<>
			<Helmet>
				<meta property="og:title" content={prefixState.info !== undefined ? prefixState.info.title : ''} />
				<meta property="og:description" content="พัฒนาอย่างใส่ใจทุกการเล่นบาคาร่า คาสิโนออนไลน์ ที่ดีที่สุด เพื่อประสบการณ์ที่ดีของผู้เล่นอย่างแท้จริง" />
				<meta property="og:image" content={prefixState.info !== undefined ? prefixState.info.icon ? prefixState.info.icon : prefixState.info.logo : ''} />
				<meta property="og:url" content={window.location.hostname} />
				<meta property="og:type" content="website" />
			</Helmet>
			{children}
		</>
	)
}

export default PrefixContainer
